import IState from '@/interfaces/IState';

export default (state: IState) => {
  return state.profile;
};
